module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "v-transition-pub"
    }
  }, [(_vm.showPub) ? _c('ad', {
    attrs: {
      "pubMsg": _vm.pubMsg
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showConnectionAlert) ? _c('div', {
    staticClass: "no-connection"
  }, [_vm._v("\n            Vous devez être connecté à internet pour mettre à jour votre agenda cet application\n        ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3bc3f2be!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 43
// module chunks = 0